import type { ProfileNotifications } from 'features/SettingsOld/interfaces/ISettings'

type PartialNotifications = Partial<ProfileNotifications>

export const getPreferencesInitialValues = (
  data: PartialNotifications,
  isDoctor: boolean,
): ProfileNotifications => {
  const notifications = {
    lease_notification: data.lease_notification,
    ticket_notification: data.ticket_notification,
    patient_cancel_notification: data.patient_cancel_notification,
    patient_confirm_notification: data.patient_confirm_notification,
    patient_reschedule_notification: data.patient_reschedule_notification,
    patient_checkin_notification: data.patient_checkin_notification,
    end_lease_notification: data.end_lease_notification,
    patient_on_site_notification: data.patient_on_site_notification,
  }

  if (!isDoctor) {
    return notifications as ProfileNotifications
  }

  return {
    ...notifications,
    accept_early_patient_check_in: data.accept_early_patient_check_in,
    accept_walk_in_patient: data.accept_walk_in_patient,
    default_appointment_time: data.default_appointment_time,
    allow_scribe: data.allow_scribe,
    appointment_color: data.appointment_color,
    confirm_appt_before: data.confirm_appt_before,
    cancel_policy_charge_days: data.cancel_policy_charge_days,
    right_away_appointment_reminder: data.right_away_appointment_reminder,
    first_appointment_reminder_before: data.first_appointment_reminder_before,
    recall_sms_before_days: data.recall_sms_before_days,
  } as ProfileNotifications
}

export const buildNotificationsPayload = (
  values: PartialNotifications,
  isDoctor: boolean,
): ProfileNotifications => {
  const numericEntries = Object.entries(values).reduce<Record<string, number>>(
    (acc, [key, value]) => {
      if (key === 'appointment_color') {
        return acc
      }

      return { ...acc, [key]: Number(value) }
    },
    {},
  )

  const payload = isDoctor
    ? { ...numericEntries, appointment_color: values.appointment_color }
    : numericEntries

  return payload as ProfileNotifications
}
